import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { TeamOutlined, UsergroupAddOutlined, UserOutlined, HistoryOutlined } from '@ant-design/icons';
import { IS_EMBEDDED } from '../config';

const { Sider, Content, Header } = Layout;

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const menuItems = [
    { key: '/', label: <Link to="/">Directory</Link>, icon: <TeamOutlined /> },
    { key: '/connections', label: <Link to="/connections">Connections</Link>, icon: <UsergroupAddOutlined /> },
    { key: '/activity', label: <Link to="/activity">Activity</Link>, icon: <HistoryOutlined /> },
    { key: '/profile', label: <Link to="/profile">My Profile</Link>, icon: <UserOutlined /> },
  ];

  if (IS_EMBEDDED) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: 13, fontWeight: 700 }}>
            Business Network
          </div>
          <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} style={{ border: 'none' }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', gap: 24, background: '#722ed1', padding: '0 24px' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>Business Network</span>
      </Header>
      <Layout>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} style={{ border: 'none', paddingTop: 8 }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    </Layout>
  );
}
